import { createSelector, createSlice } from '@reduxjs/toolkit';
import type { StorytellerState } from '../../store/StorytellerReduxState';

const storyCopierSlice = createSlice({
  name: 'storyCopierSlice',
  initialState: {
    isCopyStoryModalOpen: false,
  },
  reducers: {
    openCopyStoryModal(state) {
      state.isCopyStoryModalOpen = true;
    },
    closeCopyStoryModal(state) {
      state.isCopyStoryModalOpen = false;
    },
  },
});

export const storyCopierSliceReducer = storyCopierSlice.reducer;
export type StoryCopierSliceState = ReturnType<typeof storyCopierSliceReducer>;

export const { openCopyStoryModal, closeCopyStoryModal } = storyCopierSlice.actions;

export const storyCopierSliceSelector = (state: StorytellerState) => state.storyCopierSlice;

export const selectIsCopyStoryModalOpen = createSelector(
  storyCopierSliceSelector,
  (slice) => slice.isCopyStoryModalOpen,
);
